<template>
  <div ref="herbChart" class="herb-chart"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
  name: "HerbComparisonChart",
  data() {
    return {
      myChart: {},
      option: {},
      // 模拟五种草药的数据
      herbsData: {
        legend: ['夏枯草', '半枝莲', '白花蛇舌草', '淫羊藿', '艾草'],
        months: [], // 改为空数组，将在mounted中动态生成
        // 折线图数据 - 代表价格趋势
        lineData: [
          // 夏枯草价格
          [120, 132, 101, 134, 90, 230, 210, 180, 190, 230, 210, 250],
          // 半枝莲价格
          [220, 182, 191, 234, 290, 330, 310, 280, 290, 330, 310, 350],
          // 白花蛇舌草价格
          [150, 232, 201, 154, 190, 330, 410, 380, 390, 330, 310, 350],
          // 淫羊藿价格
          [320, 332, 301, 334, 390, 330, 320, 280, 290, 330, 310, 350],
          // 艾草价格
          [820, 932, 901, 934, 1290, 1330, 1320, 1180, 1190, 1230, 1210, 1250]
        ],
        // 柱状图数据 - 代表销售量
        barData: [
          // 夏枯草销量
          [220, 182, 191, 234, 290, 330, 310, 380, 390, 430, 410, 450],
          // 半枝莲销量
          [120, 132, 101, 134, 90, 230, 210, 180, 190, 230, 210, 250],
          // 白花蛇舌草销量
          [320, 332, 301, 334, 390, 330, 320, 380, 390, 430, 410, 450],
          // 淫羊藿销量
          [220, 282, 291, 334, 290, 330, 310, 280, 290, 330, 310, 350],
          // 艾草销量
          [420, 532, 401, 434, 590, 430, 420, 480, 490, 530, 510, 550]
        ],
        // 颜色配置
        colors: ['#ff7f50', '#87cefa', '#da70d6', '#32cd32', '#6495ed']
      }
    }
  },
  methods: {
    // 生成动态月份数组：获取当前时间的上一月向前推12个月
    generateDynamicMonths() {
      const now = new Date();
      const months = [];
      
      // 计算上一个月
      let year = now.getFullYear();
      let month = now.getMonth() - 1;
      
      // 如果当前是1月，则上一个月是去年的12月
      if (month < 0) {
        month = 11;
        year -= 1;
      }
      
      // 生成上一月向前推12个月的月份数组
      for (let i = 11; i >= 0; i--) {
        let displayMonth = month - i;
        let displayYear = year;
        
        // 处理跨年情况
        if (displayMonth < 0) {
          displayMonth += 12;
          displayYear -= 1;
        }
        
        // 添加月份到数组（格式：'YYYY-MM'）
        months.push(`${displayYear}-${String(displayMonth + 1).padStart(2, '0')}`);
      }
      
      return months;
    },
    
    initChart() {
      // 初始化图表
      this.myChart = echarts.init(this.$refs.herbChart);
      
      // 设置图表配置项
      this.option = {
        title: {
          text: '草药价格与销量对比图',
          left: 'center',
          textStyle: {
            color: '#fff',  // 改为白色
            fontSize: 16
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'cross',
            label: {
              backgroundColor: '#333'  // 调整为深色背景以更好地显示白色文字
            }
          }
        },
        legend: {
          data: this.herbsData.legend,
          top: '6%',
          textStyle: {
            color: '#fff'  // 改为白色
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            // saveAsImage: {},
            magicType: {
              show: true,
              type: ['line', 'bar']
            }
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: this.herbsData.months,
          axisLabel: {
            interval: 0,
            rotate: 30,
            color: '#fff'  // 添加白色文字设置
          },
          axisLine: {
            lineStyle: {
              color: '#666'  // 设置坐标轴线条颜色为灰色，提高可读性
            }
          }
        },
        yAxis: [
          {
            type: 'value',
            name: '价格 (元/斤)',
            position: 'left',
            nameTextStyle: {
              color: '#fff'  // 将价格标签文字设置为白色
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff'  // 添加白色文字设置
            },
            axisLine: {
              lineStyle: {
                color: '#666'  // 设置坐标轴线条颜色为灰色，提高可读性
              }
            },
            splitLine: {
              lineStyle: {
                color: '#333'  // 设置分隔线颜色为深灰色，提高可读性
              }
            }
          },
          {
            type: 'value',
            name: '销量 (斤)',
            position: 'right',
            nameTextStyle: {
              color: '#fff'  // 将销量标签文字设置为白色
            },
            axisLabel: {
              formatter: '{value}',
              color: '#fff'  // 添加白色文字设置
            },
            axisLine: {
              lineStyle: {
                color: '#666'  // 设置坐标轴线条颜色为灰色，提高可读性
              }
            },
            splitLine: {
              show: false  // 右侧Y轴不显示网格线，避免视觉混乱
            }
          }
        ],
        series: []
      };
      
      // 添加折线图系列 - 代表价格
      for (let i = 0; i < this.herbsData.legend.length; i++) {
        this.option.series.push({
          name: this.herbsData.legend[i],
          type: 'line',
          smooth: true,
          data: this.herbsData.lineData[i],
          symbol: 'circle',
          symbolSize: 8,
          itemStyle: {
            color: this.herbsData.colors[i]
          },
          emphasis: {
            focus: 'series'
          },
          yAxisIndex: 0
        });
      }
      
      // 添加柱状图系列 - 代表销量
      for (let i = 0; i < this.herbsData.legend.length; i++) {
        this.option.series.push({
          name: this.herbsData.legend[i] + '销量',
          type: 'bar',
          data: this.herbsData.barData[i],
          itemStyle: {
            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
              { offset: 0, color: this.herbsData.colors[i] + 'AA' },
              { offset: 1, color: this.herbsData.colors[i] + '44' }
            ])
          },
          emphasis: {
            focus: 'series'
          },
          yAxisIndex: 1,
          // 设置柱状图不可见（仅作为数据对比）
          show: false
        });
      }
      
      // 渲染图表
      this.myChart.setOption(this.option);
    },
    
    // 处理窗口大小变化
    handleResize() {
      if (this.myChart && !this.myChart.isDisposed()) {
        this.myChart.resize();
      }
    }
  },
  mounted() {
    // 生成动态月份数组
    this.herbsData.months = this.generateDynamicMonths();
    
    // 初始化图表
    this.initChart();
    
    // 添加窗口大小变化监听
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy() {
    // 移除窗口大小变化监听
    window.removeEventListener('resize', this.handleResize);
    
    // 销毁图表实例
    if (this.myChart && !this.myChart.isDisposed()) {
      this.myChart.dispose();
    }
  }
};
</script>

<style lang="less" scoped>
.herb-chart {
  width: 100%;
  height: 100%;
  min-height: 420px;
}
</style>